(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.headerHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
      document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);

      window.addEventListener('resizeend', () => {
        // Only update height once per resize cycle, off the main thread
        requestAnimationFrame(() => {
          this.headerHeight = this.header.offsetHeight;
          document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
          document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);
        });
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => (this.preventHide = false));
    }

    // Defer the DOM write to avoid synchronous reflow
    setHeaderHeightLive(event, zero) {
      requestAnimationFrame(() => {
        const isVisible = !this.header.classList.contains('shopify-section-header-hidden');
        const height = (zero || !isVisible) ? 0 : this.header.offsetHeight;
        document.documentElement.style.setProperty('--header-height-live', `${height}px`);
      });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
          setTimeout(() => {
            this.setHeaderHeightLive();
          }, 320);
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spp-material-samples"] && !Shopify.designMode) return;
  try {
    
  function setupSampleRequest() {
    const form = document.getElementById('SppSampleRequest');
    if (!form || form.dataset.samplesReady) return;
    form.dataset.samplesReady = 'true';
    const error = form.querySelector('[data-sample-error]');
    const summary = form.querySelector('[data-sample-summary]');
    const empty = form.querySelector('[data-summary-empty]');
    const cartButton = form.querySelector('[data-sample-cart]');
    const cartError = form.querySelector('[data-cart-error]');
    const pending = form.querySelector('[data-cart-pending]');
    const variants = JSON.parse(form.querySelector('[data-sample-variants]').textContent || '[]') || [];
    const price = form.querySelector('[data-sample-price]');
    function selectedVariant() {
      const counts = groups.map(group => group.colors.filter(color => color.checked).length);
      return variants.find(variant => variant.sku === 'SPP-MUSTER-' + counts.join('-'));
    }
    let submitting = false;
    const total = form.querySelector('[data-sample-total]');
    const groups = ['brace', 'net'].map(kind => ({
      kind,
      toggle: form.querySelector('[data-' + kind + '-toggle]'),
      panel: form.querySelector(kind === 'brace' ? '#SampleBraceColors' : '#SampleNetColors'),
      colors: [...form.querySelectorAll('[data-' + kind + '-color]')],
      count: form.querySelector('[data-' + kind + '-count]')
    }));
    const allColors = groups.flatMap(group => group.colors);
    function updateSamples() {
      const selected = allColors.filter(color => color.checked);
      allColors.forEach(color => { color.disabled = selected.length >= 5 && !color.checked; });
      total.textContent = selected.length + ' / 5';
      groups.forEach(group => {
        const colors = group.colors.filter(color => color.checked);
        group.count.textContent = colors.length + ' / 5';
        form.querySelector('[data-' + group.kind + '-selected]').textContent = colors.length + ' ' + form.dataset.selectedLabel;
      });
      summary.replaceChildren();
      groups.forEach(group => {
        const colors = group.colors.filter(color => color.checked);
        if (!colors.length) return;
        const item = document.createElement('li');
        const title = document.createElement('strong');
        title.textContent = group.toggle.querySelector('[data-category-title]').textContent + ': ';
        item.append(title, document.createTextNode(colors.map(color => color.dataset[group.kind + 'Color']).join(', ')));
        summary.append(item);
      });
      empty.hidden = selected.length > 0;
      summary.hidden = !selected.length;
      const variant = selectedVariant();
      const ready = variant?.available;
      pending.hidden = variants.length > 0;
      price.hidden = !variant;
      price.textContent = variant ? price.dataset.label + ' = ' + new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(variant.price / 100) : '';
      cartButton.disabled = submitting || !ready || !selected.length;
      if (selected.length) error.hidden = true;
    }
    groups.forEach(group => group.toggle.addEventListener('click', () => {
      group.panel.hidden = !group.panel.hidden;
      group.toggle.setAttribute('aria-expanded', String(!group.panel.hidden));
    }));
    allColors.forEach(color => color.addEventListener('change', () => {
      if (allColors.filter(item => item.checked).length > 5) color.checked = false;
      updateSamples();
    }));
    updateSamples();
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (submitting || cartButton.disabled) return;
      const selected = allColors.filter(color => color.checked);
      if (!selected.length || selected.length > 5) { error.hidden = false; return; }
      submitting = true;
      cartError.hidden = true;
      updateSamples();
      allColors.forEach(color => { color.disabled = true; });
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart.js');
        if (!response.ok) throw new Error(form.dataset.cartError);
        const cart = await response.json();
        const existing = cart.items.filter(item => item.properties?._spp_sample === 'true' || item.sku?.startsWith('SPP-MUSTER-'));
        if (cart.items.some(item => !existing.includes(item))) throw new Error(form.dataset.cartSeparate);
        if (existing.length) throw new Error(form.dataset.cartExisting);
        const properties = { '_spp_sample': 'true', '_spp_sample_count': String(selected.length) };
        groups.forEach(group => {
          const colors = group.colors.filter(color => color.checked).map(color => color.dataset[group.kind + 'Color']);
          if (colors.length) properties[group.kind === 'brace' ? form.dataset.braceProperty : form.dataset.netProperty] = colors.join(', ');
        });
        const variant = selectedVariant();
        if (!variant?.available) throw new Error(form.dataset.cartError);
        const items = [{ id: variant.id, quantity: 1, properties }];
        const added = await fetch(root + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
        });
        const result = await added.json();
        if (!added.ok) throw new Error(result.description || form.dataset.cartError);
        window.location.assign(form.dataset.cartUrl);
      } catch (failure) {
        cartError.textContent = failure.message || form.dataset.cartError;
        cartError.hidden = false;
        submitting = false;
        updateSamples();
      }
    });
    const handle = new URLSearchParams(window.location.search).get('product');
    if (handle && /^[a-z0-9][a-z0-9-]{0,250}$/.test(handle)) {
      const root = window.Shopify?.routes?.root || '/';
      const path = root + 'products/' + handle;
      const back = document.querySelector('[data-sample-back]');
      if (back) { back.href = path; back.hidden = false; }
    }
  }
  setupSampleRequest();
  document.addEventListener('shopify:section:load', setupSampleRequest);

  } catch(e) { console.error(e); }
})();
})();
